// extracted by mini-css-extract-plugin
export default {"manage-bulk-email":"ManageBulkEmail_manage-bulk-email__hcKG0"};